import React from 'react'
import { FeatureType } from '@trustero/trustero-api-web/lib/trust/trust_pb'
import { FEATURE_TYPE_LABELS } from 'src/pages/TrustAccessManagement/visitoranalytics/VisitorAnalytics.constants'
import { FilterName, FilterParam } from '../../../../FilterBar.types'
import { FilterDropdown } from '../../../FilterDropdown'

export const DashboardTPFeatureFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const filterValues =
    Object.values(FeatureType).map((featureType) => ({
      label: FEATURE_TYPE_LABELS[featureType as FeatureType],
      value: featureType.toString(),
    })) || []

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_TP_FEATURE_DIMENSION}
      filterName={FilterName.DASHBOARD_TP_FEATURE_DIMENSION}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
